import { connect } from 'react-redux';
import {
  PROBE_GET_KAFKA_TOPICS_REQUEST,
  PROBE_GET_KAFKA_TOPIC_SAMPLE_REQUEST,
} from 'js/constants/actionTypes';
import { probeGetKafkaTopics, probeGetKafkaTopicSample } from 'js/actions';
import KafkaTopicsList from './KafkaTopicsList';

const mapStateToProps = (state, ownProps) => {
  const { request, probe } = state;
  const { selectedCredentialId } = ownProps;
  const { samples } = probe[selectedCredentialId] || {};
  const isLoadingTopics = !!request[PROBE_GET_KAFKA_TOPICS_REQUEST];
  const isLoadingSample = !!request[PROBE_GET_KAFKA_TOPIC_SAMPLE_REQUEST];

  return {
    samples,
    isLoadingTopics,
    isLoadingSample,
  };
};

export default connect(mapStateToProps, {
  probeGetKafkaTopics,
  probeGetKafkaTopicSample,
})(KafkaTopicsList);
